import ImageConverterTemplate from "../components/ImageConverterTemplate";

export default function ConvertIcoToWebp() {
  return (
    <ImageConverterTemplate
      sourceFormat="ICO"
      targetFormat="WebP"
      acceptTypes=".ico,image/x-icon,image/vnd.microsoft.icon"
      slug="convert-ico-to-webp"
      gradientColors="from-cyan-500 to-green-500"
      accentColor="green"
      showQualitySlider={true}
    />
  );
}
